export function domReady(listener: () => void) {
  if (document.readyState !== 'loading') {
    listener();
  } else {
    document.addEventListener('DOMContentLoaded', listener);
  }
}
